import React from "react";
import { useSelector } from "react-redux";
import { FileManagement } from "./index";
import FileManagementH5 from "./FileManagementH5";

const ResponsiveFileManagement = (props) => {
  const { isPC = true } = useSelector((state) => state.App ?? {});

  if (isPC) {
    return <FileManagement {...props} />;
  }

  return (
    <div className="file-manage-mobile-page">
      <FileManagementH5 {...props} />
    </div>
  );
};

export default React.memo(ResponsiveFileManagement);
